import { render, staticRenderFns } from "./LianJianLabelDialog.vue?vue&type=template&id=4c6ffccb&scoped=true"
import script from "./LianJianLabelDialog.vue?vue&type=script&lang=js"
export * from "./LianJianLabelDialog.vue?vue&type=script&lang=js"
import style0 from "./LianJianLabelDialog.vue?vue&type=style&index=0&id=4c6ffccb&prod&scoped=true&lang=css"
import style1 from "./LianJianLabelDialog.vue?vue&type=style&index=1&id=4c6ffccb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6ffccb",
  null
  
)

export default component.exports